/* Category circle rail: centered active item plus context-aware arrows. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = window.matchMedia('(min-width: 900px)');

  function railArrows(root) {
    var rail = root.querySelector('[data-rail]');
    var prev = root.querySelector('[data-rail-prev]');
    var next = root.querySelector('[data-rail-next]');
    if (!rail || !prev || !next) return;

    function circles() {
      return Array.prototype.slice.call(rail.querySelectorAll('.dm-circle'));
    }

    function step() {
      var c = rail.querySelector('.dm-circle');
      if (!c) return Math.round(rail.clientWidth * 0.7);
      var gap = parseFloat(window.getComputedStyle(rail).columnGap) || 16;
      return c.offsetWidth + gap;
    }

    function updateActive() {
      var items = circles();
      if (!items.length) return;

      if (desktop.matches) {
        items.forEach(function (item) { item.classList.remove('is-active'); });
        return;
      }

      var railBox = rail.getBoundingClientRect();
      var centre = railBox.left + railBox.width / 2;
      var active = items.reduce(function (best, item) {
        var box = item.getBoundingClientRect();
        var distance = Math.abs((box.left + box.right) / 2 - centre);
        return !best || distance < best.distance ? { item: item, distance: distance } : best;
      }, null);

      items.forEach(function (item) {
        item.classList.toggle('is-active', !!active && item === active.item);
      });
    }

    var ticking = false;
    function update() {
      ticking = false;
      updateActive();

      var max = rail.scrollWidth - rail.clientWidth;
      var overflows = max > 4;
      if (!overflows) {
        prev.hidden = true;
        next.hidden = true;
        prev.disabled = false;
        next.disabled = false;
        return;
      }

      var x = rail.scrollLeft;
      var atStart = x <= 2;
      var atEnd = x >= max - 2;
      if (atStart && document.activeElement === prev) rail.focus({ preventScroll: true });
      if (atEnd && document.activeElement === next) rail.focus({ preventScroll: true });
      prev.hidden = atStart;
      next.hidden = atEnd;
      prev.disabled = false;
      next.disabled = false;
    }

    function go(dir) {
      rail.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });

    rail.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }, { passive: true });

    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    if (desktop.addEventListener) desktop.addEventListener('change', update);
    if (window.ResizeObserver) new ResizeObserver(update).observe(rail);

    update();
  }

  function boot() {
    document.querySelectorAll('[data-circles]').forEach(railArrows);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
